import { render, staticRenderFns } from "./ConfirmationChangesDialog.vue?vue&type=template&id=0e99db3c&scoped=true"
import script from "./ConfirmationChangesDialog.vue?vue&type=script&lang=js"
export * from "./ConfirmationChangesDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e99db3c",
  null
  
)

export default component.exports